import React, { useContext } from "react";
import { ButtonGroup, Button, Row, Table } from "reactstrap";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import { ItemDropdownMenu } from ".";
import { helpers, reportHelpers, UserContext, constants } from "../utils";

export default function SampleItemGrid(props) {
  const { currentUser } = useContext(UserContext);
  let canEdit = currentUser?.isAPUCS;

  return (
    <>
      <Row>
        <Table size="sm" className="data-table">
          <thead className="table-header">
            <tr>
              <th width="11%">Customer<br />P/N</th>
              {!currentUser?.isAnyCustomerTypeRole && <th width="11%">Item</th>}
              <th width="4%">Units</th>
              <th width="4%">Std<br />Qty</th>
              <th width="4%">Min<br />Order Qty</th>
              <th width="4%">Price</th>
              {canEdit && (
                <>
                  <th width="4%">Cost</th>
                  <th width="4%">GPM</th>
                  <th width="4%">Percent<br />Markup</th>
                </>
              )}
              <th>
                {props.data && props.data.length ? (
                  <ButtonGroup className="float-end">
                    {props.exportXlsxCallback
                      ? (<Button
                          title="Download as .xlsx"
                          className="shredButtonExcel mx-1"
                          style={{fontSize: "1.333rem"}}
                          onClick={props.exportXlsxCallback}
                        >
                          <FontAwesomeIcon icon="file-excel" />
                        </Button>)
                      : null
                    }
                    {props.exportPdfCallback
                      ? (<Button
                          title="Download as .pdf"
                          className="shredButton mx-1"
                          style={{fontSize: "1.333rem"}}
                          onClick={props.exportPdfCallback}
                        >
                          <FontAwesomeIcon icon="file-pdf" />
                        </Button>)
                      : null
                    }
                  </ButtonGroup>
                ) : null}
              </th>
            </tr>
          </thead>
          <tbody>
            {_.map(props.data, (s, index) => (
              <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                <td
                  className="data-cell"
                  onClick={() => reportHelpers.getCustomerSpecReport(s.customerId, s.itemNumber)}
                  title="Print Customer Spec Report"
                >
                  <span className="shredLink fw-bold cursor-pointer">
                    {s.customerItemNumber}
                  </span>
                </td>
                {!currentUser?.isAnyCustomerTypeRole && (
                  <ItemDropdownMenu
                    itemNumber={s.itemNumber}
                    itemDescription={s.itemWithDescription}
                    attachmentCount={s.attachmentCount}
                    attachmentTypeId={constants.ATTACHMENT_TYPES.SampleItemRequest}
                  />
                )}
                <td className="data-cell">{s.unitOfMeasure}</td>
                <td className="data-cell">{s.stdNetWeight ? s.stdNetWeight.toLocaleString() : ""}</td>
                <td className="data-cell">{s.minOrderQty.toLocaleString()}</td>
                <td className="data-cell">{helpers.formatCurrency(s.listPrice)}</td>
                {canEdit && (
                  <>
                    <td className="data-cell">{helpers.formatCurrency(s.totalCost)}</td>
                    <td className="data-cell">{helpers.formatCurrency(s.profitMargin)}</td>
                    <td className="data-cell">{`${helpers.roundNum(s.markupPercent * 100).toLocaleString()} %`}</td>
                  </>
                )}
                <td className="data-cell" onClick={() => props.addToCartCallback(s)}>
                  <AiOutlineShoppingCart className="cart-icon" />
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="table-footer">
            <tr>
              <td colSpan="11" />
            </tr>
          </tfoot>
        </Table>
      </Row>
    </>
  );
}
